'use strict';

exports.uniqueConnectionsByCustomers = require('./uniqueConnectionsByCustomers');
exports.featuresByPercentCustomers = require('./featuresByPercentCustomers');
exports.dataByCustomers = require('./dataByCustomers');
exports.customerByDeviceCount = require('./customerByDeviceCount');
exports.customerByLocationCount = require('./customerByLocationCount');
exports.customerByPluginCount = require('./customerByPluginCount');
exports.customerByPortalCount = require('./customerByPortalCount');
exports.customerBySSIDCount = require('./customerBySSIDCount');
exports.customerByCellCount = require('./customerByCellCount');
exports.customerBySsidProfile = require('./customerBySsidProfile');
exports.featuresByCustomers = require('./featuresByCustomers');
exports.pluginsByCustomer = require('./pluginsByCustomer');
exports.customerTrend = require('./customerTrend');
exports.deviceTrend = require('./deviceTrend');
exports.newCustomerTrend = require('./newCustomerTrend');
exports.newDeviceTrend = require('./newDeviceTrend');
exports.guestCorporateDataTrend = require('./guestCorporateDataTrend');
exports.pluginUsageTrend = require('./pluginUsageTrend');
exports.featureUsageTrend = require('./featureUsageTrend');
exports.topCustomerUsingData = require('./topCustomerUsingData');

